import React, { useMemo, useState } from 'react';
import ScoreRuler from './ScoreRuler';
import ResultSection from './ResultSection';

function Calculator({ criteria, type, title, description, headingLevel = 2 }) {
  const [selectedIds, setSelectedIds] = useState(new Set());

  const selectedItems = useMemo(
    () => criteria.filter((item) => selectedIds.has(item.id)),
    [criteria, selectedIds],
  );

  const total = useMemo(() => {
    const sum = selectedItems.reduce((value, item) => value + item.points, 0);
    return Number(sum.toFixed(1));
  }, [selectedItems]);

  const toggleCriterion = (id) => {
    setSelectedIds((current) => {
      const next = new Set(current);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const resetCriteria = () => setSelectedIds(new Set());

  return (
    <section className="well-panel" aria-label={title}>
      <div className="panel-heading">
        {headingLevel === 1 ? <h1>{title}</h1> : <h2>{title}</h2>}
        <p>{description}</p>
      </div>

      <div className="criteria-panel">
        <div className="criteria-heading">
          <div>
            <h2>Quais critérios estão presentes?</h2>
            <p>Marque somente os itens avaliados.</p>
          </div>
          <button className="text-button" type="button" onClick={resetCriteria}>
            Limpar
          </button>
        </div>

        <div className="criteria-list">
          {criteria.map((item) => (
            <label className="criterion-row" key={item.id}>
              <input
                type="checkbox"
                checked={selectedIds.has(item.id)}
                onChange={() => toggleCriterion(item.id)}
              />
              <span className="criterion-copy">
                <span className="criterion-label">{item.label}</span>
                {item.hint && <span className="criterion-hint">{item.hint}</span>}
              </span>
              <span className="criterion-points">
                {item.points > 0 ? '+' : ''}
                {item.points} {Math.abs(item.points) === 1 ? 'ponto' : 'pontos'}
              </span>
            </label>
          ))}
        </div>
      </div>

      <div className="result-slot">
        <ResultSection total={total} selectedItems={selectedItems} type={type} />
      </div>

      <ScoreRuler total={total} selectedItems={selectedItems} type={type} />
    </section>
  );
}

export default Calculator;
